import { Injectable } from '@angular/core';
import { SupabaseBaseHttpService } from '@examdojo/supabase';
import { from } from 'rxjs';
import { UserHttpModel, UserRole } from '@examdojo/models/user';

@Injectable({ providedIn: 'root' })
export class UserRoleBindingsHttpService extends SupabaseBaseHttpService<'user_role_bindings', 'public'> {
  readonly schema = 'public';
  readonly tableName = 'user_role_bindings';

  updateUserRole(userId: UserHttpModel['id'], newRole: UserRole) {
    return from(
      this.supabase.client.schema(this.schema).rpc('admin_update_user_role', {
        user_id: userId,
        new_role: newRole,
      }),
    );
  }
}
